import { createStyles, Theme } from '@material-ui/core/styles';

export default ({ spacing: { unit } }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
    },
    retryInfoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      paddingBlock: `${unit / 2}px`,
      '& > p': {
        padding: 0,
        margin: 0,
      },
    },
    iconsAndDateWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1,
    },
    icon: {
      fontSize: 13,
      marginRight: unit / 2,
    },
    createdAt: {
      marginRight: unit / 2,
    },
    messageInfoVoicePlayer: {
      display: 'inline-block',
      float: 'left',
      padding: `0px ${unit / 2}px`,
    },
    metadata: {
      whiteSpace: 'pre-line',
    },
  });
